import {ChangeDetectorRef, Component, EventEmitter, inject, Input, Output} from '@angular/core';
import {
  CheckboxElementComponent,
  IAction,
  ICheckboxFormElement,
  ITextFormElement,
  TextElementComponent,
} from 'frontier/browserkit';
import {IEPostConfig} from './epost-config-form.interface';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {EControlActions, EsvgFiles} from 'frontier/nucleus';
import {MatButton} from '@angular/material/button';
import {MatIcon} from '@angular/material/icon';
import {NgIf} from '@angular/common';
import {Observable} from 'rxjs';
import {MatDivider} from '@angular/material/divider';
import {
  JSON_EXPORT_ACTION,
  JSON_IMPORT_ACTION
} from "frontier/browserkit/src/lib/components/control/table-control/default-form-actions.constant";


@Component({
  selector: 'app-epost-config',
  templateUrl: './epost-config-form.component.html',
  styleUrls: ['./epost-config-form.component.scss'],
  standalone: true,
  imports: [NgIf, MatIcon, TextElementComponent, CheckboxElementComponent, MatButton, MatDivider],
})
export class EpostConfigFormComponent {
  private _cdr: ChangeDetectorRef = inject(ChangeDetectorRef);
  fb: FormBuilder = inject(FormBuilder);
  EsvgFiles = EsvgFiles;

  actions: IAction[] = [
    JSON_EXPORT_ACTION,
    JSON_IMPORT_ACTION,
  ];

  @Input() set ePostConfig(config: IEPostConfig) {
    if (config == null) return;
    this.form.patchValue(config, {emitEvent: false});
    this._cdr.detectChanges();
  };

  @Output() requestSmsClicked: EventEmitter<void> = new EventEmitter();
  @Output() healthCheckClicked: EventEmitter<void> = new EventEmitter();
  @Output() callActionFunction: EventEmitter<EControlActions> = new EventEmitter<EControlActions>();

  form: FormGroup = this.fb.group({
    active: this.fb.control(null),
    ekpNumber: this.fb.control(null, [Validators.required]),
    duplex: this.fb.control(null, [Validators.required]),
    color: this.fb.control(null, [Validators.required]),
    senderName: this.fb.control(null, [Validators.required]),
    senderStreet: this.fb.control(null, [Validators.required]),
    senderHouseNumber: this.fb.control(null, [Validators.required]),
    senderPostCode: this.fb.control(null, [Validators.required]),
    senderCity: this.fb.control(null, [Validators.required])
  });

  @Output() formChange: Observable<IEPostConfig> = this.form.valueChanges;

  epkText: ITextFormElement = {
    inputType: 'text',
    label: 'Ihre E-Post-Kundennummer'
  };
  duplex: ICheckboxFormElement = {
    displayAs: 'toggle',
    label: 'Beidseitiger Druck (Duplex)',
    key: 'duplex',
  };
  color: ICheckboxFormElement = {
    displayAs: 'toggle',
    label: 'Farbig drucken',
    key: 'color'
  };

  isActive(): boolean {
    return this.form.get('active').value === true;
  }

  onRequestSms(): void {
    this.requestSmsClicked.emit()
  }

  onHealthCheck(): void {
    this.healthCheckClicked.emit();
  }
}
